const PunchTypeEnum = {
  Normal: 1,
  Lunch: 2,
  Business: 3,
  PersonalBusiness: 4,
};
const AttendanceTypeEnum = {
  In: 1,
  Out: 2,
};

const CurrencyType = [
  { id: 1, label: "Indian Rupee (₹)" },
  { id: 2, label: "US Dollar ($)" },
  { id: 3, label: "Australian Dollar (A$)" },
  { id: 4, label: "Brazilian Real (R$)" },
  { id: 5, label: "British Pound (£)" },
  { id: 6, label: "Canadian Dollar (C$)" },
  { id: 7, label: "Chinese Yuan (¥)" },
  { id: 8, label: "Euro (€)" },
  { id: 9, label: "Hong Kong Dollar (HK$)" },
  { id: 10, label: "Japanese Yen (¥)" },
  { id: 11, label: "Mexican Peso (Mex$)" },
  { id: 12, label: "New Zealand Dollar (NZ$)" },
  { id: 13, label: "Russian Ruble (₽)" },
  { id: 14, label: "Saudi Riyal (﷼)" },
  { id: 15, label: "Singapore Dollar (S$)" },
  { id: 16, label: "South African Rand (R)" },
  { id: 17, label: "South Korean Won (₩)" },
  { id: 18, label: "Swiss Franc (CHF)" },
  { id: 19, label: "Turkish Lira (₺)" },
  { id: 20, label: "UAE Dirham (د.إ)" }
];


const ReceiptMethodType = [
  { id: 1, label: "Shipping to Receive Goods" },
  { id: 2, label: "Delivered Directly to Me" },
  { id: 3, label: "Personally Pick Up Goods" },
  { id: 4, label: "Nothing to Deliver" },
];

const PaymentType = [
  { id: 1, label: "Reimbursement" },
  { id: 2, label: "Cheque Request" },
  { id: 3, label: "Pay When Billed" },
  { id: 4, label: "Cash Advance" },
  { id: 5, label: "COD" },
];

const EpoPurchaseStatus = [
  { id: "1", label: "I am the user of the product to be purchased" },
  { id: "2", label: "Epo Ready for Payment" },
];

const UserPermissionNames = {
  ADMIN_ADD_EMPLOYEE: "Admin_AddEmployee",
  ADMIN_DISPLAY_ALL_EMPLOYEES: "Admin_DisplayAllEmployees",
  ADMIN_EMPLOYEE_LIMIT: "Admin_EmployeeLimit",
  ADMIN_APPROVAL_DOCUMENT_PERSON: "Admin_ApprovalDocumentPerson",
  DASHBOARD_DASHBOARD: "Dashboard_Dashboard",
  T_A_IN_OUT_FOR_LUNCH: "T&A_In/OutforLunch",
  T_A_IN_OUT_FOR_BUSINESS: "T&A_In/OutforBusiness",
  T_A_IN_OUT_FOR_PERSONAL_BUSINESS: "T&A_In/OutforPersonalBusiness",
  T_A_MY_MISSING_PUNCHES: "T&A_MyMissingPunches",
  T_A_MY_TIME_PUNCH_RECORDS: "T&A_MyTimePunchRecords",
  T_A_WHO_IS_IN_THE_BUILDING: "T&A_WhoisIntheBuilding",
  EPO_Manage: "EPO_ManageEPO",
  EPO_MPC_EPO_VIEWER: "EPO_MPCEPOViewer",
  EPO_MPC_VOTE_FOR_EPO: "EPO_MPCVoteForEPO",
  EPO_MY_EPOS: "EPO_MyEPOs",
  EPO_VIEW_MY_SUB_ORDINATES_EPO: "EPO_ViewMySubordinatesEPO",
  EPO_REVIEW: "EPO_ReviewEPO",
  EPO_MY_APPROVAL_FOR_EPO: "EPO_MyApprovalForEPO",
  FTO_SUBMIT_NEW_REQUEST: "FTO_SubmitNewFTORequest",
  FTO_APPROVE: "FTO_ApproveFTO",
  FTO_HR_APPROVAL: "FTO_FTOHRApproval",
  FTO_APPROVAL: "FTO_FTOApproval",
  FTO_REVIEW_YTD_STATUS: "FTO_ReviewYTDFTOStatus",
  FTO_SHOW_ALL_DEPT: "FTO_ShowAllFTOOfMyDept",
  FTO_SHOW_ALL_FUTURE_DEPT: "FTO_ShowAllFutureFTOOfMyDept",
  FTO_Addvisitor: "FTO_Addvisitor",
  DOCUMENTS_ALL: "Documents_AllDocuments",
  DOCUMENTS_CREATE_NEW_ECN: "Documents_CreateNewECN",
  DOCUMENTS_CREATE_NEW_FCD: "Documents_CreateNewFCD",
  DOCUMENTS_CREATE_NEW_LIT: "Documents_CreateNewLIT",
  DOCUMENTS_CREATE_NEW_SOP: "Documents_CreateNewSOP",
  DOCUMENTS_CREATE_NEW_WI: "Documents_CreateNewWI",
  DOCUMENTS_AWAITING_MY_APPROVAL: "Documents_DocumentawaitingmyApproval",
  ROLES_PERMISSIONS: "Roles_Roles&Permissions",
  HR_PreRecruitment_Process : "HR_Pre Recruitment Process",
  HR_Evaluation_Process : "HR_Evaluation_Process",
  HR_All_Recruitees : "HR_All Recruitees",
  HR_Employee_Of_The_Month_Nomination :"HR_Employee Of The Month Nomination",
  HR_Welcome_New_Employee:"HR_Welcome New Employee",
  HR_Lets_Know_Each_other_details:"HR_Lets Know Each other details",
  HR_Gate_Pass:"HR_Gate Pass",
  HR_Leave_Sheet:"HR_Leave Sheet",
  HR_Training_Courses:"HR_Training Courses",
  HR_Training:"HR_Training",
  HR_Email_For_Training:"HR_Email For Training",
  HR_AddQuestion  : "HR_AddQuestion",
  HR_ALLQuestion  : "HR_ALLQuestion",
  HR_GetCandidateResume:"HR_GetCandidateResume",
  HR_AddCandidateResume:"HR_AddCandidateResume",
  HR_AddCandidateResume:"HR_AddCandidateResume",
  HR_AddCandidateResume:"HR_AddCandidateResume",
  HR_AddCandidateResume:"HR_AddCandidateResume",
  HR_HR_Round:"HR_HR_Round",
  HR_Technical_Round2:"HR_Technical_Round2",
  HR_Technical_Round1:"HR_Technical_Round1",
  HR_Genral_Evalution:"HR_Genral_Evalution",
  SECURITY_SCREEN:"SECURITY_SCREEN",
}

const TabAccess = {
  Interviewer: ["General"],
  Manager: ["General", "Technical Round 1"],
  HR: ["General", "Technical Round 1", "Technical Round 2", "HR Round"],
};
const TabPermissions = {
  General: UserPermissionNames.HR_Evaluation_Process, // or any specific permission
  TechnicalRound1: "Some_Permission_For_Tech1",
  TechnicalRound2: "Some_Permission_For_Tech2",
  HRRound: "Some_Permission_For_HRRound",
};


const AddressType = {
  currentAddressType: 1,
  permanentAddressType: 2,
};

module.exports.enums = {
  AttendanceTypeEnum,
  PunchTypeEnum,
  CurrencyType,
  ReceiptMethodType,
  EpoPurchaseStatus,
  PaymentType,
  UserPermissionNames,
  AddressType,
  TabAccess,
};